import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = '/' }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Supervisors and F2F interviewers must complete their profile (phone) AND verify
  // their email before reaching any other page (CATI interviewers are never gated). Only truly-new accounts are hard-blocked
  // (email_verification_required); existing accounts backfilled with the sentinel
  // date keep access and are only softly prompted. Send blocked users to /profile;
  // the `blocked` flag tells the profile page to pop the modal.
  if (
    (user?.role === 'superviseur' || (user?.role === 'enqueteur' && !user?.is_cati)) &&
    (user?.profile_complete === false || user?.email_verification_required === true) &&
    location.pathname !== '/profile'
  ) {
    return <Navigate to="/profile" replace state={{ profileBlocked: true }} />;
  }

  // Check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    // Redirect to home page for all users
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
